import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { configService } from '@/config'
import { ContactForm } from '@/components/ContactForm'
import { ExternalLink, MessageCircle } from 'lucide-react'

export const Footer: React.FC = () => {
  const appConfig = configService.getAppConfig()
  const currentNetwork = configService.getCurrentNetworkConfig()
  const [isContactFormOpen, setIsContactFormOpen] = useState(false)

  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider">
              About
            </h3>
            <div className="mt-4 space-y-2">
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {appConfig.name} provides comprehensive blockchain analytics for the X1 ecosystem.
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                powered by <a href="https://www.fortiblox.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors">Fortiblox</a>
              </p>
            </div>
          </div>

          {/* Documentation */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider">
              Documentation
            </h3>
            <div className="mt-4 space-y-2">
              <a 
                href="https://docs.fortiblox.com/docs/explorer/intro" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors group"
              >
                <span>Explorer Documentation</span>
                <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
              </a>
            </div>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider">
              Support
            </h3>
            <div className="mt-4 space-y-2">
              <button
                onClick={() => setIsContactFormOpen(true)}
                className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors group"
              >
                <MessageCircle className="w-4 h-4" />
                <span>Contact Support</span>
              </button>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              © 2025 X1 Blockchain Explorer. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0 flex space-x-6">
              <Link to="/disclaimer" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary-600">
                Disclaimer
              </Link>
              <Link to="/brand" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary-600">
                Brand Guidelines
              </Link>
              <a href="#" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary-600">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary-600">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form Modal */}
      <ContactForm 
        isOpen={isContactFormOpen} 
        onClose={() => setIsContactFormOpen(false)} 
      />
    </footer>
  )
}
